import { render, staticRenderFns } from "./myCouseAchievement.vue?vue&type=template&id=18052820&scoped=true&lang=true"
import script from "./myCouseAchievement.vue?vue&type=script&lang=js"
export * from "./myCouseAchievement.vue?vue&type=script&lang=js"
import style0 from "./myCouseAchievement.vue?vue&type=style&index=0&id=18052820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18052820",
  null
  
)

export default component.exports